import React from 'react';
import { CourseManagementSection } from './CourseManagementNav';
import { ErrorBoundary } from '../ContentManagementProject/shared/ErrorBoundary';
import { CourseGeneration } from './sections/CourseGeneration/CourseGeneration';
import { CoursePromptManagement } from './sections/PromptManagement/CoursePromptManagement';
import { CourseSharedResources } from './sections/SharedResources/CourseSharedResources';
import { CourseDesignSection } from './design/CourseDesignSection';

const CourseManagementProject: React.FC<{
  activeSection?: CourseManagementSection;
}> = ({ activeSection = 'courses' }) => {
  let content: React.ReactNode;
  let label: string;

  switch (activeSection) {
    case 'prompts':
      content = <CoursePromptManagement />;
      label = 'Prompts';
      break;
    case 'supporting-data':
      content = <CourseSharedResources />;
      label = 'Supporting Data';
      break;
    case 'design':
      content = <CourseDesignSection />;
      label = 'Course Design';
      break;
    case 'courses':
    default:
      content = <CourseGeneration />;
      label = 'Course Generation';
      break;
  }

  return <ErrorBoundary key={activeSection} label={label}>{content}</ErrorBoundary>;
};

export default CourseManagementProject;
